<div class="fdm_file">
      <div class="title" [ngClass]="{
        selected:isSelected,
        processing:isProcessing,
        uploading:isUploading,
        incomplete:file.incomplete,
        plottable:canPlot
      }" (click)="clicked()">
         {{ file.name }} <small>{{ file.dataType?.name }}</small>
      </div>
  </div>